import autobind from 'autobind-decorator';
import * as Draft from 'draft-js';
import * as DraftJsButtons from 'draft-js-buttons';
import {
  BlockTypeSelectStyles,
  ButtonStyles,
  ToolbarStyles
} from 'draft-js-buttons';
import * as React from 'react';

export interface BlockTypeSelectTheme {
  buttonStyles: ButtonStyles;
  toolbarStyles: ToolbarStyles;
  blockTypeSelectStyles: BlockTypeSelectStyles;
}

// region component props
interface ExternalProps {
  children: (externalProps: DraftJsButtons.ButtonProps) => React.ReactNode;

  theme: BlockTypeSelectTheme;
  getEditorState: () => Draft.EditorState;
  setEditorState: (editorState: Draft.EditorState) => void;
}

type InternalProps = Required<ExternalProps>;

type Props = InternalProps;

interface State {
  style: { [k: string]: string };
}

// endregion

/**
 *
 */
class BlockTypeSelect extends React.Component<Props, State> {
  static readonly defaultProps = {};

  /**
   * The name to use for jss classes.
   *
   * Easiest way to get this class' original name
   * without pissing off typescript, or modifying
   * every decorator with annoying hacks.
   *
   * @type {string}
   */
  static readonly jssName: string = BlockTypeSelect.name;

  readonly state: State = {
    style: {
      transform: 'translate(-50%) scale(0)'
    }
  };

  // region autobound methods
  @autobind
  handleMouseEnter() {
    this.setState({
      style: {
        transform: 'translate(-50%) scale(1)',
        transition: 'transform 0.15s cubic-bezier(.3,1.2,.2,1)'
      }
    });
  }

  @autobind
  handleMouseLeave() {
    this.setState({
      style: {
        transform: 'translate(-50%) scale(0)'
      }
    });
  }

  @autobind
  handleMouseDown(clickEvent: React.SyntheticEvent<HTMLDivElement>) {
    clickEvent.preventDefault();
    clickEvent.stopPropagation();
  }

  // endregion
  // region render & get-render-content methods
  render() {
    const { theme, getEditorState, setEditorState } = this.props;

    return (
      <div
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
        onMouseDown={this.handleMouseDown}
      >
        <div className={theme.blockTypeSelectStyles.blockType}>
          <svg
            height="24"
            viewBox="0 0 24 24"
            width="24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M0 0h24v24H0z" fill="none" />
            <path d="M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z" />
          </svg>
        </div>
        {/*
          The spacer is needed so the popup doesn't go away when moving from the
          blockType div to the popup.
        */}
        <div className={theme.blockTypeSelectStyles.spacer} />
        <div
          className={theme.blockTypeSelectStyles.popup}
          style={this.state.style}
        >
          {this.props.children({
            getEditorState,
            setEditorState,
            theme: theme.buttonStyles
          })}
        </div>
      </div>
    );
  }

  // endregion
}

export default BlockTypeSelect;
